import { axios } from '@/utils/request'

const api = {
  // 黑名单分页查询
  blackListPage: '/blackList/page',

  blackListList: '/blackList/list',
  // 黑名单还原（删除）
  blackListDelete: '/blackList/delete',
  // 拉黑
  blackListSave: '/blackList/save',

  // 业务类型条件查询
  businessTypeListByCondition: '/businessType/list',
  // 业务类型分页查询
  businessTypePage: '/businessType/page',
  // 业务类型删除
  businessTypeDelete: '/businessType/delete',
  // 业务类型添加
  businessTypeSave: '/businessType/save',
  // 业务类型修改
  businessTypeUpdate: '/businessType/update',
  // 业务类型查询所有
  businessTypeList: '/businessType/findAll',

  // 卡号条件查询
  cardList: '/card/list',
  // 卡号分页查询
  cardPage: '/card/page',
  // 卡号删除
  cardDelete: '/card/delete',
  // 卡号添加
  cardSave: '/card/save',
  cardSaveBatch: '/card/saveBatch',
  // 卡号修改
  cardUpdate: '/card/update',

  // 供应商分页查询
  corpSupplierPage: '/corpSupplier/page',
  // 供应商增加
  corpSupplierSave: '/corpSupplier/save',
  // 供应商修改
  corpSupplierUpdate: '/corpSupplier/update',
  // 供应商删除
  corpSupplierDelete: '/corpSupplier/delete',
  // 供应商查询所有
  corpSupplierList: '/corpSupplier/findAllList',
  // 同步供应商数据
  corpSupplierSyncData: '/corpSupplier/syncData',
  // 根据物料查询关联的供应商
  findSupplierByMaterielId: '/corpSupplier/findSupplierByMaterielId',


  // 客户分页查询
  corpBusinessPage: '/corpBusiness/page',
  // 客户增加
  corpBusinessSave: '/corpBusiness/save',
  // 客户修改
  corpBusinessUpdate: '/corpBusiness/update',
  // 客户删除
  corpBusinessDelete: '/corpBusiness/delete',
  //客户查询所有
  corpBusinessList: '/corpBusiness/findAll',
  // 根据物料查询关联的客户
  findBusinessByMaterielId: '/corpBusiness/findBusinessByMaterielId',
  // 根据物料查询关联的业务类型
  findBusinessTypeByMaterielId: '/businessType/findBusinessTypeByMaterielId',
  // 根据客户编号查询对应的客户
  selectBusinessByCode: '/corpBusiness/selectByCode',
  // 同步客户数据
  corpBusinessSyncData: '/corpBusiness/syncData',

  // 物流公司分页查询
  corpLogisticsPage: '/corpLogistics/page',
  // 物流公司增加
  corpLogisticsSave: '/corpLogistics/save',
  // 物流公司修改
  corpLogisticsUpdate: '/corpLogistics/update',
  // 物流公司删除
  corpLogisticsDelete: '/corpLogistics/delete',
  //物流公司查询所有
  corpLogisticsList: '/corpLogistics/findAll',
  //同步物流公司数据
  corpLogisticsSyncData: '/corpLogistics/syncData',

  // 驾驶员分页查询
  driverPage: '/driver/page',
  // 驾驶员增加
  driverSave: '/driver/save',
  // 驾驶员修改
  driverUpdate: '/driver/update',
  // 驾驶员删除
  driverDelete: '/driver/delete',
  //驾驶员查询所有
  driverList: '/driver/findAll',


  // 押运员分页查询
  escortPage: '/escort/page',
  // 押运员增加
  escortSave: '/escort/save',
  // 押运员修改
  escortUpdate: '/escort/update',
  // 押运员删除
  escortDelete: '/escort/delete',


  // 厂区条件查询
  factoryList: '/factory/list',
  // 厂区分页查询
  factoryPage: '/factory/page',
  // 厂区删除
  factoryDelete: '/factory/delete',
  // 厂区添加
  factorySave: '/factory/save',
  // 厂区修改
  factoryUpdate: '/factory/update',
  // 厂区查询所有
  // factoryList: '/factory/findAllList',

  // 厂区门禁条件查询
  factoryDoorList: '/factoryDoor/list',
  // 厂区门禁分页查询
  factoryDoorPage: '/factoryDoor/page',
  // 厂区门禁删除
  factoryDoorDelete: '/factoryDoor/delete',
  // 厂区门禁添加
  factoryDoorSave: '/factoryDoor/save',
  // 厂区门禁修改
  factoryDoorUpdate: '/factoryDoor/update',

  // 厂区装卸货点条件查询
  factoryLoadList: '/factoryLoad/list',
  // 厂区装卸货点分页查询
  factoryLoadPage: '/factoryLoad/page',
  // 厂区装卸货点删除
  factoryLoadDelete: '/factoryLoad/delete',
  // 厂区装卸货点添加
  factoryLoadSave: '/factoryLoad/save',
  // 厂区装卸货点修改
  factoryLoadUpdate: '/factoryLoad/update',
  // 厂区装卸货点设置物料
  factoryLoadSetMateriel: '/factoryLoad/setMateriel',

  // 厂区卸料口条件查询
  factoryLoadPortList: '/factoryLoadPort/list',
  // 厂区卸料口分页查询
  factoryLoadPortPage: '/factoryLoadPort/page',
  // 厂区卸料口删除
  factoryLoadPortDelete: '/factoryLoadPort/delete',
  // 厂区卸料口添加
  factoryLoadPortSave: '/factoryLoadPort/save',
  // 厂区卸料口修改
  factoryLoadPortUpdate: '/factoryLoadPort/update',

  // 物料分页查询
  materielPage: '/materiel/page',
  // 物料增加
  materielSave: '/materiel/save',
  // 物料删除
  materielDelete: '/materiel/delete',
  //物料查询所有deleted=0
  materielList: '/materiel/findAllList',

  findAllByMark: '/materiel/findAllByMark',

  findAllByMarkCustomer: '/materiel/findAllByMarkCustomer',
  //物料查询全部
  materielAllList: '/materiel/findAllDeleteList',
  //同步原材料、材料、倒料
  materielSyncData: '/materiel/syncData',
  // 根据装卸货点查询物料
  materielFindMaterielByFactoryLoad: '/materiel/findMaterielByFactoryLoad',
  findNameOrCode: '/materiel/findNameOrCode',
  checkMaterielNameIsExist: '/materiel/checkMaterielNameIsExist',
  checkMaterielCodeIsExist: '/materiel/checkMaterielCodeIsExist',
  // 根据客户查询关联的物料
  findMaterielByBusinessId: '/materiel/findMaterielByBusinessId',
  materieLinkBusiness: '/materiel/linkBusiness',
  materieLinkSupplier: '/materiel/linkSupplier',
  materieLinkBusinessType: '/materiel/linkBusinessType',

  // 根据业务类型ID查询物料
  findListByBusinessTypeId: '/materiel/findListByBusinessTypeId',

  // 货物价格分页查询
  materielPricePage: '/materielPrice/page',

  priceLinkBusiness: '/materielPrice/getPriceLinkBusiness',
  // 货物价格增加
  materielPriceSave: '/materielPrice/save',

  // 货物价格增加
  materielPriceSavetiaojia: '/materielPrice/savetiaojia',
  // 货物价格删除
  materielPriceDelete: '/materielPrice/delete',

  // 货物对应客户等级的货物单价查询
  materielPriceselectBycodelevel: '/materielPrice/selectBycodelevel',


  // 货物价格调整明细分页查询
  materielPricedetailPage: '/materielPricedetail/page',


  // 货物价格调整明细审批
  materielPricedetailSave: '/materielPricedetail/save',

  // 货物价格调整明细删除
  materielPricedetaildeletedetail: '/materielPricedetail/deletedetail',

  //收款金额审核
  updateaccount: '/receipt/updateaccount',

  //绑定微信openid
  updateOpenId: '/WXBangDing/getOpenId',
  // 订单分页查询
  orderPage: '/order/page',
  // 订单增加
  orderSave: '/order/save',
  // 订单删除
  orderDelete: '/order/delete',

  // 物料分组条件查询
  materielGroupList: '/materielGroup/list',
  // 物料分组分页查询
  materielGroupPage: '/materielGroup/page',
  // 物料分组删除
  materielGroupDelete: '/materielGroup/delete',
  // 物料分组添加
  materielGroupSave: '/materielGroup/save',
  // 物料分组修改
  materielGroupUpdate: '/materielGroup/update',

  // 装卸料时间条件查询
  materielLoadTimeList: '/materielLoadTime/list',
  // 装卸料时间分页查询
  materielLoadTimePage: '/materielLoadTime/page',
  // 装卸料时间删除
  materielLoadTimeDelete: '/materielLoadTime/delete',
  // 装卸料时间添加
  materielLoadTimeSave: '/materielLoadTime/save',
  // 装卸料时间修改
  materielLoadTimeUpdate: '/materielLoadTime/update',

  // 批次管理分页查询
  materielBatchPage: '/materielBatchBasic/page',
  //批次管理分页添加
  materielBatchSave: '/materielBatchBasic/save',
  //批次管理分页删除
  materielBatchDelete: '/materielBatchBasic/delete',
  //批次管理分页修改
  materielBatchUpdate: '/materielBatchBasic/update',
  materielBatchList: '/materielBatchBasic/list',
  //获取批次号
  materielBatchNumber: '/materielBatchBasic/batchNumber',
  // 车辆信息分页查询
  vehiclePage: '/vehicle/page',
  // 车辆信息增加
  vehicleSave: '/vehicle/save',
  // 车辆信息修改
  vehicleUpdate: '/vehicle/update',
  // 车辆信息删除
  vehicleDelete: '/vehicle/delete',
  // 所有车辆信息
  vehicleList: '/vehicle/findAll',
  //模糊查询车号
  findscanquery: '/vehicle/findscanquery',
  //模糊查询车号by车号
  findscanquerybycarno: '/vehicle/findscanquerybycarno',
  //查询车型信息
  findcartypeinfo: '/vehicle/findcartypeinfo',
  //查询车辆信息
  //模糊查询车号
  findcarnoinfo: '/vehicle/findcarnoinfo',

  queryDriverInfo: '/vehicle/queryDriverInfo',

  // 车辆类型分页查询
  vehicleTypePage: '/vehicleType/page',
  //  所有车型信息
  vehicleTypeList: '/vehicleType/findAll',
  // 车辆类型增加
  vehicleTypeSave: '/vehicleType/save',
  // 车辆类型修改
  vehicleTypeUpdate: '/vehicleType/update',
  // 车辆类型删除
  vehicleTypeDelete: '/vehicleType/delete',

  findCarTypeById: '/vehicleType/findCarTypeById',
  // 发卡车号查询
  cardvehicleList: '/vehicleDiscern/vehicleList',

  // 收卡车号查询
  recovercardvehicleList: '/vehicleDiscern/recovervehicleList',


  // 根据车号查询车辆采样信息
  vehicleSamplingFindByVehicleNo: '/vehicleSampling/findByVehicleNo',

  vehicleSamplingSave: '/vehicleSampling/save',
  //  查询厂外销售排队叫号信息
  queueCallPage: '/queueCall/list',
  //   查询厂内销售排队叫号信息
  queueCallPageFactory: '/queueCall/listFactory',

  //  查询厂外采购排队叫号信息
  queueCallPurchasePage: '/queueCall/listPurchase',
  //  查询厂外采购排队叫号信息
  queueCallPurchasePageFactory: '/queueCall/listPurchaseFactory',
  //  查询叫号数据
  getCallData: '/sellCall/getCallData',

  //  厂内查询叫号数据
  getCallDataFactory: '/sellCall/getCallDataFactory',
  // 使用企业查询所有
  corpCompanyList: '/corpCompany/findAll',
  corpCompanyPage: '/corpCompany/page',
  corpCompanySave: '/corpCompany/save',
  corpCompanyDelete: '/corpCompany/delete',
  updateFromAudit: '/corpBusiness/updateFromAudit',
  //客户自己约的代码
  selectCodeByCustomer: '/corpBusiness/selectCodeByCustomer',
  // 云天基础数据
  ytsoftFindByType: '/ytsoft/findByType',
  // 获取云天字典基础数据
  ytsoftBasicInfo: '/ytsoft/getBasicInfo',

  weighingLimitList: '/weighingLimit/list',
  materWeighingLimitList: '/weighingLimit/materList',
  weighingLimitSave: '/weighingLimit/save',
  materWeighingLimitDelete: '/weighingLimit/delete',
  getCompanyInfo: '/common/companyInfo',
  getIp: '/common/getIp',

  corpBusinessExport: '/corpBusiness/exportCorpBussinessExcel'
}

export default api

/**
 * 黑名单管理
 * @param parameter
 * @returns {*}
 */
export function blackListPage(parameter) {
  return axios({
    url: api.blackListPage,
    method: 'get',
    params: parameter
  })
}

export function cardvehicleList(parameter) {
  return axios({
    url: api.cardvehicleList,
    method: 'get',
    params: parameter
  })
}

export function recovercardvehicleList(parameter) {
  return axios({
    url: api.recovercardvehicleList,
    method: 'get',
    params: parameter
  })
}




export function blackListList(parameter) {
  return axios({
    url: api.blackListList,
    method: 'get',
    params: parameter
  })
}

export function blackListDelete(parameter) {
  return axios({
    url: api.blackListDelete,
    method: 'get',
    params: parameter
  })
}

export function blackListSave(parameter) {
  return axios({
    url: api.blackListSave,
    method: 'post',
    data: parameter
  })
}


// 业务类型条件查询
export function businessTypeListByCondition(parameter) {
  return axios({
    url: api.businessTypeListByCondition,
    method: 'get',
    params: parameter
  })
}

// 业务类型分页查询
export function businessTypePage(parameter) {
  return axios({
    url: api.businessTypePage,
    method: 'get',
    params: parameter
  })
}

// 业务类型删除
export function businessTypeDelete(parameter) {
  return axios({
    url: api.businessTypeDelete,
    method: 'get',
    params: parameter
  })
}

// 业务类型添加
export function businessTypeSave(parameter) {
  return axios({
    url: api.businessTypeSave,
    method: 'post',
    data: parameter
  })
}

//业务类型修改
export function businessTypeUpdate(parameter) {
  return axios({
    url: api.businessTypeUpdate,
    method: 'post',
    data: parameter
  })
}

//业务类型查询所有
export function businessTypeList(parameter) {
  return axios({
    url: api.businessTypeList,
    method: 'get',
    params: parameter
  })
}



// 卡号条件查询
export function cardList(parameter) {
  return axios({
    url: api.cardList,
    method: 'get',
    params: parameter
  })
}

// 卡号分页查询
export function cardPage(parameter) {
  return axios({
    url: api.cardPage,
    method: 'get',
    params: parameter
  })
}

// 卡号删除
export function cardDelete(parameter) {
  return axios({
    url: api.cardDelete,
    method: 'get',
    params: parameter
  })
}

// 卡号添加
export function cardSave(parameter) {
  return axios({
    url: api.cardSave,
    method: 'post',
    data: parameter
  })
}

export function cardSaveBatch(parameter) {
  return axios({
    url: api.cardSaveBatch,
    method: 'post',
    data: parameter
  })
}

//卡号修改
export function cardUpdate(parameter) {
  return axios({
    url: api.cardUpdate,
    method: 'post',
    data: parameter
  })
}


/**
   * 供应商管理
   * @param parameter
   * @returns {*}
   */
export function getCorpSupplierPage(parameter) {
  return axios({
    url: api.corpSupplierPage,
    method: 'get',
    params: parameter
  })
}

export function corpSupplierDelete(parameter) {
  console.log('getcorpSupplierDelete>>>' + parameter)
  return axios({
    url: api.corpSupplierDelete,
    method: 'post',
    data: parameter
  })
}

export function corpSupplierUpdate(parameter) {
  return axios({
    url: api.corpSupplierUpdate,
    method: 'post',
    data: parameter
  })
}

export function corpSupplierSave(parameter) {
  return axios({
    url: api.corpSupplierSave,
    method: 'post',
    data: parameter
  })
}

export function getCorpSupplierList(parameter) {
  return axios({
    url: api.corpSupplierList,
    method: 'get',
    params: parameter
  })
}


export function corpSupplierSyncData(parameter) {
  return axios({
    url: api.corpSupplierSyncData,
    method: 'post',
    params: parameter
  })
}

/**
   * 客户管理
   * @param parameter
   * @returns {*}
   */
export function corpBusinessPage(parameter) {
  return axios({
    url: api.corpBusinessPage,
    method: 'get',
    params: parameter
  })
}

export function selectBusinessByCode(parameter) {
  return axios({
    url: api.selectBusinessByCode,
    method: 'get',
    params: parameter
  })
}


/**
 * 同步客户数据
 * @param parameter
 * @returns {*}
 */
export function corpBusinessSyncData(parameter) {
  console.log('corpBusinessSyncData>>>')
  return axios({
    url: api.corpBusinessSyncData,
    method: 'post',
    params: parameter
  })
}

export function corpBusinessDelete(parameter) {
  return axios({
    url: api.corpBusinessDelete,
    method: 'post',
    data: parameter
  })
}

export function corpBusinessUpdate(parameter) {
  return axios({
    url: api.corpBusinessUpdate,
    method: 'post',
    data: parameter
  })
}

export function corpBusinessSave(parameter) {
  return axios({
    url: api.corpBusinessSave,
    method: 'post',
    data: parameter
  })
}

export function corpBusinessList(parameter) {
  return axios({
    url: api.corpBusinessList,
    method: 'get',
    params: parameter
  })
}

export function findBusinessByMaterielId(parameter) {
  return axios({
    url: api.findBusinessByMaterielId,
    method: 'get',
    params: parameter
  })
}

export function findBusinessTypeByMaterielId(parameter) {
  return axios({
    url: api.findBusinessTypeByMaterielId,
    method: 'get',
    params: parameter
  })
}

export function findSupplierByMaterielId(parameter) {
  return axios({
    url: api.findSupplierByMaterielId,
    method: 'get',
    params: parameter
  })
}

/**
   * 物流公司管理
   * @param parameter
   * @returns {*}
   */
export function corpLogisticsPage(parameter) {
  return axios({
    url: api.corpLogisticsPage,
    method: 'get',
    params: parameter
  })
}

export function corpLogisticsDelete(parameter) {
  return axios({
    url: api.corpLogisticsDelete,
    method: 'post',
    data: parameter
  })
}

export function corpLogisticsUpdate(parameter) {
  return axios({
    url: api.corpLogisticsUpdate,
    method: 'post',
    data: parameter
  })
}

export function corpLogisticsSave(parameter) {
  return axios({
    url: api.corpLogisticsSave,
    method: 'post',
    data: parameter
  })
}

export function corpLogisticsList(parameter) {
  return axios({
    url: api.corpLogisticsList,
    method: 'get',
    params: parameter
  })
}
/**
 * 同步物流公司数据
 * @param parameter
 * @returns {*}
 */
export function corpLogisticsSyncData(parameter) {
  return axios({
    url: api.corpLogisticsSyncData,
    method: 'post',
    params: parameter
  })
}

/**
   * 驾驶员管理
   * @param parameter
   * @returns {*}
   */
export function driverPage(parameter) {
  return axios({
    url: api.driverPage,
    method: 'get',
    params: parameter
  })
}

export function driverDelete(parameter) {
  return axios({
    url: api.driverDelete,
    method: 'post',
    data: parameter
  })
}

export function driverUpdate(parameter) {
  return axios({
    url: api.driverUpdate,
    method: 'post',
    data: parameter
  })
}

export function driverSave(parameter) {
  return axios({
    url: api.driverSave,
    method: 'post',
    data: parameter
  })
}

export function driverList(parameter) {
  return axios({
    url: api.driverList,
    method: 'get',
    params: parameter
  })
}


//使用企业查询所有
export function corpCompanyList(parameter) {
  return axios({
    url: api.corpCompanyList,
    method: 'get',
    params: parameter
  })
}

export function corpCompanyPage(parameter) {
  return axios({
    url: api.corpCompanyPage,
    method: 'get',
    params: parameter
  })
}

export function corpCompanySave(parameter) {
  return axios({
    url: api.corpCompanySave,
    method: 'post',
    data: parameter
  })
}


export function updateFromAudit() {
  return axios({
    url: api.updateFromAudit,
    method: 'get'
  })
}

export function selectCodeByCustomer() {
  return axios({
    url: api.selectCodeByCustomer,
    method: 'get'
  })
}



export function corpCompanyDelete(parameter) {
  return axios({
    url: api.corpCompanyDelete,
    method: 'post',
    params: parameter
  })
}

// 厂区条件查询
// export function factoryListByCondition (parameter) {
//   return axios({
//     url: api.factoryListByCondition,
//     method: 'get',
//     params: parameter
//   })
// }

// 厂区分页查询
export function factoryPage(parameter) {
  return axios({
    url: api.factoryPage,
    method: 'get',
    params: parameter
  })
}

// 厂区删除
export function factoryDelete(parameter) {
  return axios({
    url: api.factoryDelete,
    method: 'get',
    params: parameter
  })
}

// 厂区添加
export function factorySave(parameter) {
  return axios({
    url: api.factorySave,
    method: 'post',
    data: parameter
  })
}

//厂区修改
export function factoryUpdate(parameter) {
  return axios({
    url: api.factoryUpdate,
    method: 'post',
    data: parameter
  })
}

// 厂区查询所有
export function factoryList(parameter) {
  return axios({
    url: api.factoryList,
    method: 'get',
    params: parameter
  })
}


// 厂区门禁条件查询
export function factoryDoorList(parameter) {
  return axios({
    url: api.factoryDoorList,
    method: 'get',
    params: parameter
  })
}

// 厂区门禁分页查询
export function factoryDoorPage(parameter) {
  return axios({
    url: api.factoryDoorPage,
    method: 'get',
    params: parameter
  })
}

// 厂区门禁删除
export function factoryDoorDelete(parameter) {
  return axios({
    url: api.factoryDoorDelete,
    method: 'get',
    params: parameter
  })
}

// 厂区门禁添加
export function factoryDoorSave(parameter) {
  return axios({
    url: api.factoryDoorSave,
    method: 'post',
    data: parameter
  })
}

//厂区门禁修改
export function factoryDoorUpdate(parameter) {
  return axios({
    url: api.factoryDoorUpdate,
    method: 'post',
    data: parameter
  })
}


// 厂区装卸货点条件查询
export function factoryLoadList(parameter) {
  return axios({
    url: api.factoryLoadList,
    method: 'get',
    params: parameter
  })
}

// 厂区装卸货点分页查询
export function factoryLoadPage(parameter) {
  return axios({
    url: api.factoryLoadPage,
    method: 'get',
    params: parameter
  })
}

// 厂区装卸货点删除
export function factoryLoadDelete(parameter) {
  return axios({
    url: api.factoryLoadDelete,
    method: 'get',
    params: parameter
  })
}

// 厂区装卸货点添加
export function factoryLoadSave(parameter) {
  return axios({
    url: api.factoryLoadSave,
    method: 'post',
    data: parameter
  })
}

//厂区装卸货点修改
export function factoryLoadUpdate(parameter) {
  return axios({
    url: api.factoryLoadUpdate,
    method: 'post',
    data: parameter
  })
}

// 装卸货点设置物料
export function factoryLoadSetMateriel(parameter) {
  return axios({
    url: api.factoryLoadSetMateriel,
    method: 'get',
    params: parameter
  })
}


// 厂区装卸料口条件查询
export function factoryLoadPortList(parameter) {
  return axios({
    url: api.factoryLoadPortList,
    method: 'get',
    params: parameter
  })
}

// 厂区装卸料口分页查询
export function factoryLoadPortPage(parameter) {
  return axios({
    url: api.factoryLoadPortPage,
    method: 'get',
    params: parameter
  })
}

// 厂区装卸料口删除
export function factoryLoadPortDelete(parameter) {
  return axios({
    url: api.factoryLoadPortDelete,
    method: 'get',
    params: parameter
  })
}

// 厂区装卸料口添加
export function factoryLoadPortSave(parameter) {
  return axios({
    url: api.factoryLoadPortSave,
    method: 'post',
    data: parameter
  })
}

//厂区装卸料口修改
export function factoryLoadPortUpdate(parameter) {
  return axios({
    url: api.factoryLoadPortUpdate,
    method: 'post',
    data: parameter
  })
}


/**
   * 物料管理
   * @param parameter
   * @returns {*}
   */
export function getMaterielPage(parameter) {
  return axios({
    url: api.materielPage,
    method: 'get',
    params: parameter
  })
}

export function findNameOrCode(parameter) {
  return axios({
    url: api.findNameOrCode,
    method: 'get',
    params: parameter
  })
}

export function materielDelete(parameter) {
  return axios({
    url: api.materielDelete,
    method: 'post',
    data: parameter
  })
}

export function materielSave(parameter) {
  return axios({
    url: api.materielSave,
    method: 'post',
    data: parameter
  })
}

export function priceLinkBusiness(parameter) {
  return axios({
    url: api.priceLinkBusiness,
    method: 'get',
    params: parameter
  })
}

export function getMaterielPricePage(parameter) {
  return axios({
    url: api.materielPricePage,
    method: 'get',
    params: parameter
  })
}



export function materielPriceselectBycodelevel(parameter) {
  return axios({
    url: api.materielPriceselectBycodelevel,
    method: 'get',
    params: parameter
  })
}


export function getMaterielPricedetailPage(parameter) {
  return axios({
    url: api.materielPricedetailPage,
    method: 'get',
    params: parameter
  })
}

export function materielPriceDelete(parameter) {
  return axios({
    url: api.materielPriceDelete,
    method: 'post',
    data: parameter
  })
}

export function materielPriceSave(parameter) {
  return axios({
    url: api.materielPriceSave,
    method: 'post',
    data: parameter
  })
}

export function materielPriceSavetiaojia(parameter) {
  return axios({
    url: api.materielPriceSavetiaojia,
    method: 'post',
    data: parameter
  })
}

export function materielPricedetailSave(parameter) {
  return axios({
    url: api.materielPricedetailSave,
    method: 'post',
    data: parameter
  })
}


export function updateaccount(parameter) {
  return axios({
    url: api.updateaccount,
    method: 'post',
    data: parameter
  })
}

export function updateOpenId(parameter) {
  return axios({
    url: api.updateOpenId,
    method: 'post',
    data: parameter
  })
}


export function orderPage(parameter) {
  return axios({
    url: api.orderPage,
    method: 'post',
    data: parameter
  })
}

export function orderDelete(parameter) {
  return axios({
    url: api.orderDelete,
    method: 'post',
    data: parameter
  })
}

export function orderSave(parameter) {
  return axios({
    url: api.orderSave,
    method: 'post',
    data: parameter
  })
}
export function materielList(parameter) {
  return axios({
    url: api.materielList,
    method: 'get',
    params: parameter
  })
}

export function findAllByMark(parameter) {
  return axios({
    url: api.findAllByMark,
    method: 'get',
    params: parameter
  })
}

export function findAllByMarkCustomer(parameter) {
  return axios({
    url: api.findAllByMarkCustomer,
    method: 'get',
    params: parameter
  })
}


export function materielPricedetaildeletedetail(parameter) {
  return axios({
    url: api.materielPricedetaildeletedetail,
    method: 'get',
    params: parameter
  })
}

export function materielAllList(parameter) {
  return axios({
    url: api.materielAllList,
    method: 'get',
    params: parameter
  })
}

export function materielSyncData(parameter) {
  return axios({
    url: api.materielSyncData,
    method: 'post',
    params: parameter
  })
}

export function materielFindMaterielByFactoryLoad(parameter) {
  return axios({
    url: api.materielFindMaterielByFactoryLoad,
    method: 'get',
    params: parameter
  })
}

export function checkMaterielNameIsExist(parameter) {
  return axios({
    url: api.checkMaterielNameIsExist,
    method: 'get',
    params: parameter
  })
}

export function checkMaterielCodeIsExist(parameter) {
  return axios({
    url: api.checkMaterielCodeIsExist,
    method: 'get',
    params: parameter
  })
}

export function findMaterielByBusinessId(parameter) {
  return axios({
    url: api.findMaterielByBusinessId,
    method: 'get',
    params: parameter
  })
}

export function materieLinkBusiness(parameter) {
  return axios({
    url: api.materieLinkBusiness,
    method: 'get',
    params: parameter
  })
}

export function materieLinkSupplier(parameter) {
  return axios({
    url: api.materieLinkSupplier,
    method: 'get',
    params: parameter
  })
}

export function materieLinkBusinessType(parameter) {
  return axios({
    url: api.materieLinkBusinessType,
    method: 'get',
    params: parameter
  })
}

export function findListByBusinessTypeId(parameter) {
  return axios({
    url: api.findListByBusinessTypeId,
    method: 'get',
    params: parameter
  })
}
// 物料分组条件查询
export function materielGroupList(parameter) {
  return axios({
    url: api.materielGroupList,
    method: 'get',
    params: parameter
  })
}

// 物料分组分页查询
export function materielGroupPage(parameter) {
  return axios({
    url: api.materielGroupPage,
    method: 'get',
    params: parameter
  })
}

// 物料分组删除
export function materielGroupDelete(parameter) {
  return axios({
    url: api.materielGroupDelete,
    method: 'get',
    params: parameter
  })
}

// 物料分组添加
export function materielGroupSave(parameter) {
  return axios({
    url: api.materielGroupSave,
    method: 'post',
    data: parameter
  })
}

//物料分组修改
export function materielGroupUpdate(parameter) {
  return axios({
    url: api.materielGroupUpdate,
    method: 'post',
    data: parameter
  })
}


// 装卸料时间条件查询
export function materielLoadTimeList(parameter) {
  return axios({
    url: api.materielLoadTimeList,
    method: 'get',
    params: parameter
  })
}

// 装卸料时间分页查询
export function materielLoadTimePage(parameter) {
  return axios({
    url: api.materielLoadTimePage,
    method: 'get',
    params: parameter
  })
}

// 装卸料时间删除
export function materielLoadTimeDelete(parameter) {
  return axios({
    url: api.materielLoadTimeDelete,
    method: 'get',
    params: parameter
  })
}

// 装卸料时间添加
export function materielLoadTimeSave(parameter) {
  return axios({
    url: api.materielLoadTimeSave,
    method: 'post',
    data: parameter
  })
}

// 装卸料时间修改
export function materielLoadTimeUpdate(parameter) {
  return axios({
    url: api.materielLoadTimeUpdate,
    method: 'post',
    data: parameter
  })
}
// 批次管理分页查询
export function materielBatchPage(parameter) {
  return axios({
    url: api.materielBatchPage,
    method: 'get',
    params: parameter
  })
}
//批次管理添加
export function materielBatchSave(parameter) {
  return axios({
    url: api.materielBatchSave,
    method: 'post',
    data: parameter
  })
}
//批次管理修改
export function materielBatchUpdate(parameter) {
  return axios({
    url: api.materielBatchUpdate,
    method: 'post',
    data: parameter
  })
}
//批次管理删除
export function materielBatchDelete(parameter) {
  return axios({
    url: api.materielBatchDelete,
    method: 'get',
    params: parameter
  })
}
// 批次管理列表
export function materielBatchList(parameter) {
  return axios({
    url: api.materielBatchList,
    method: 'get',
    params: parameter
  })
}
// 获取批次号
export function materielBatchNumber(parameter) {
  return axios({
    url: api.materielBatchNumber,
    method: 'get',
    params: parameter
  })
}
/**
 * 车辆信息管理
 * @param parameter
 * @returns {*}
 */
export function vehiclePage(parameter) {
  return axios({
    url: api.vehiclePage,
    method: 'get',
    params: parameter
  })
}

export function vehicleSave(parameter) {
  return axios({
    url: api.vehicleSave,
    method: 'post',
    data: parameter
  })
}

export function vehicleUpdate(parameter) {
  return axios({
    url: api.vehicleUpdate,
    method: 'post',
    data: parameter
  })
}

export function vehicleDelete(parameter) {
  return axios({
    url: api.vehicleDelete,
    method: 'post',
    data: parameter
  })
}

export function vehicleList(parameter) {
  return axios({
    url: api.vehicleList,
    method: 'get',
    params: parameter
  })
}


export function findscanquery(parameter) {
  return axios({
    url: api.findscanquery,
    method: 'get',
    params: parameter
  })
}

export function findscanquerybycarno(parameter) {
  return axios({
    url: api.findscanquerybycarno,
    method: 'get',
    params: parameter
  })
}

export function findcartypeinfo(parameter) {
  return axios({
    url: api.findcartypeinfo,
    method: 'get',
    params: parameter
  })
}

export function queryDriverInfo(parameter) {
  return axios({
    url: api.queryDriverInfo,
    method: 'get',
    params: parameter
  })
}



export function findcarnoinfo(parameter) {
  return axios({
    url: api.findcarnoinfo,
    method: 'get',
    params: parameter
  })
}




/**
 * 车型信息管理
 * @param parameter
 * @returns {*}
 */
export function vehicleTypePage(parameter) {
  return axios({
    url: api.vehicleTypePage,
    method: 'get',
    params: parameter
  })
}

export function vehicleTypeList(parameter) {
  return axios({
    url: api.vehicleTypeList,
    method: 'get',
    params: parameter
  })
}

export function vehicleTypeSave(parameter) {
  return axios({
    url: api.vehicleTypeSave,
    method: 'post',
    data: parameter
  })
}

export function vehicleTypeUpdate(parameter) {
  return axios({
    url: api.vehicleTypeUpdate,
    method: 'post',
    data: parameter
  })
}

export function vehicleTypeDelete(parameter) {
  return axios({
    url: api.vehicleTypeDelete,
    method: 'post',
    data: parameter
  })
}


export function getwxcodekk(url) {
  return axios({
    url: url,
    method: 'get',
    params: {}
  })
}

export function findCarTypeById(parameter) {
  return axios({
    url: api.findCarTypeById,
    method: 'get',
    params: parameter
  })
}



export function queueCallPage(parameter) {
  return axios({
    url: api.queueCallPage,
    method: 'get',
    params: parameter
  })
}

export function queueCallPageFactory(parameter) {
  return axios({
    url: api.queueCallPageFactory,
    method: 'get',
    params: parameter
  })
}

export function queueCallPurchasePage(parameter) {
  return axios({
    url: api.queueCallPurchasePage,
    method: 'get',
    params: parameter
  })
}

export function queueCallPurchasePageFactory(parameter) {
  return axios({
    url: api.queueCallPurchasePageFactory,
    method: 'get',
    params: parameter
  })
}
export function vehicleSamplingFindByVehicleNo(parameter) {
  return axios({
    url: api.vehicleSamplingFindByVehicleNo,
    method: 'get',
    params: parameter
  })
}

export function ytsoftFindByType(parameter) {
  return axios({
    url: api.ytsoftFindByType,
    method: 'get',
    params: parameter
  })
}

export function ytsoftBasicInfo(parameter) {
  return axios({
    url: api.ytsoftBasicInfo,
    method: 'get',
    params: parameter
  })
}


export function getCompanyInfo(parameter) {
  return axios({
    url: api.getCompanyInfo,
    method: 'get',
    params: parameter
  })
}

export function weighingLimitList(parameter) {
  return axios({
    url: api.weighingLimitList,
    method: 'get',
    params: parameter
  })
}

export function materWeighingLimitList(parameter) {
  return axios({
    url: api.materWeighingLimitList,
    method: 'get',
    params: parameter
  })
}

export function weighingLimitSave(parameter) {
  return axios({
    url: api.weighingLimitSave,
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function materWeighingLimitDelete(parameter) {
  return axios({
    url: api.materWeighingLimitDelete,
    method: 'post',
    data: parameter,
  })
}


export function escortPage(parameter) {
  return axios({
    url: api.escortPage,
    method: 'get',
    params: parameter
  })
}

export function escortDelete(parameter) {
  return axios({
    url: api.escortDelete,
    method: 'post',
    data: parameter
  })
}

export function escortUpdate(parameter) {
  return axios({
    url: api.escortUpdate,
    method: 'post',
    data: parameter
  })
}

export function escortSave(parameter) {
  return axios({
    url: api.escortSave,
    method: 'post',
    data: parameter
  })
}

export function getCallData(parameter) {
  return axios({
    url: api.getCallData,
    method: 'get',
    params: parameter
  })
}

export function getCallDataFactory(parameter) {
  return axios({
    url: api.getCallDataFactory,
    method: 'get',
    params: parameter
  })
}

export function getIp(parameter) {
  return axios({
    url: api.getIp,
    method: 'get',
    params: parameter
  })
}

export function vehicleSamplingSave(parameter) {
  return axios({
    url: api.vehicleSamplingSave,
    method: 'post',
    data: parameter
  })
}

export function corpBusinessExport(parameter) {
  return axios({
    url: api.corpBusinessExport,
    method: 'post',
    data: parameter
  })
}

